export default __webpack_public_path__ + "static/media/shopping-cart.a0c1ce70.svg";